module.exports = __webpack_public_path__ + "static/media/calitrees.509be137.png";